<template>
  <div class="login">
    <div class="login__container">
      <div class="login__container__header">
        <div class="login__container__header__icon">
          <svg-icon iconClass="logoShape" className="login__container__header__icon--logo"></svg-icon>
          <svg-icon iconClass="logoText" className="login__container__header__icon--text"></svg-icon>
        </div>
        <div class="login__container__header__text">
          {{ $t('login.accountBind') }}
        </div>
      </div>
      <div class="login__container__form">
        <el-input v-model="email" :placeholder="$t('login.email')" v-on:keyup.enter.native="onLogin"></el-input>
        <el-input
          v-model="password"
          :placeholder="$t('login.password')"
          show-password
          v-on:keyup.enter.native="onLogin"
          @blur="onBlur"
          ref="password"
          class="password"
        ></el-input>
        <el-checkbox v-model="privacyChecked" v-if="is_quickapp">{{ $t('login.agree') }}</el-checkbox
        ><el-link
          v-if="is_quickapp"
          type="primary"
          :underline="false"
          @click="redirectToPrivacy"
          style="position: relative; top: -1px"
          >{{ $t('login.privacy') }}</el-link
        >
        <el-button
          type="primary"
          @click="onLoginWithBlur"
          v-baidu-event-tracking="{ feature: '绑定账号页操作', action: '登录按钮' }"
          :loading="loading"
          >{{ $t('bindAccount.confirm') }}</el-button
        >
        <div class="flex justify-center items-center">
          <el-link
            v-baidu-event-tracking="{ feature: '绑定账号页操作', action: '忘记密码' }"
            :underline="false"
            @click="redirectToForgetpassword"
            >{{ $t('login.forget_password') }}</el-link
          >
        </div>
      </div>
    </div>
    <BindOtherAccountDialog />
  </div>
</template>

<script>
import DBUtil from '../utils/DBUtil.js'

import BindOtherAccountDialog from '../components/BindOtherAccountDialog.vue'
export default {
  components: {
    BindOtherAccountDialog,
  },
  data() {
    return {
      email: '',
      password: '',
      privacyChecked: false,
      is_quickapp: false,
      isZh: true,
      loading: false,
      in_wechat: false,
      showWxLogin: false,
    }
  },
  computed: {
    wechatAccount() {
      return this.$store.getters['wxLogin/wechatAccount']
    },
    appleAccount() {
      return this.$store.getters['appleLogin/account']
    },
  },
  methods: {
    clickWxLogin() {
      if (this.in_wechat) {
        this.$message.error(this.$t('login.message.wechat_login'))
        return
      }
      this.$store.dispatch('wxLogin/get')
    },
    // fix ios flomo app auto fill password
    onLoginWithBlur() {
      this.$refs.password.blur()
      setTimeout(() => {
        this.onLogin()
      }, 300)
    },
    onLogin() {
      if (!this.email) {
        this.$message.error(this.$t('login.message.fill_email'))
        return
      }
      if (!this.password) {
        const password = document.querySelector('.password input').value
        if (!password) {
          this.$message.error(this.$t('login.message.fill_password'))
          return
        } else {
          this.password = password
        }
      }

      if (this.is_quickapp && !this.privacyChecked) {
        this.$message.error(this.$t('login.message.check_privacy'))
        return
      }

      this.loading = true
      const { wechatAccount, appleAccount } = this

      const wechat_union_id = wechatAccount?.union_id ?? ''
      const wechat_oa_open_id = wechatAccount?.oa_open_id ?? ''
      const apple_sub = appleAccount?.sub ?? ''

      this.$api.call(
        'POST',
        '/user/login_by_email',
        {
          email: this.email.trim(),
          password: this.password.trim(),
          wechat_union_id,
          wechat_oa_open_id,
          apple_sub,
        },
        async (response) => {
          console.log(response)

          if (!response.data) {
            this.loading = false
            return
          }
          if (response.data.code == '-101') {
            this.$store.dispatch('wxLogin/updateBindOtherAccountDialog', true)
          }
          if (response.data.code == 0) {
            if (response.data.data.access_token) {
              this.$store.commit('setMe', response.data.data)

              await DBUtil.clearDB()
              // 有 access_token 才算登录成功
              setTimeout(() => {
                this.$router.replace({
                  name: 'mine',
                })
              }, 300)
            } else {
              this.$message.error(response.data.message)
            }
          }
          this.loading = false
        },
      )
    },
    redirectToForgetpassword() {
      this.$router.push({
        name: 'forget',
      })
    },
    redirectToRegister() {
      this.$router.push({
        name: 'register',
      })
    },
    redirectToHome() {
      window.location.replace('https://flomoapp.com')
    },
    redirectToPrivacy() {
      window.open('/privacy/')
    },

    redirectToSignUp() {
      // window.location.replace("/register2/");
      this.$router.push({
        name: 'register',
      })
    },
    onBlur(e) {
      this.password = e.target.value
    },
  },
  created() {
    this.isZh = window.navigator.language.toLowerCase().slice(0, 2) === 'zh'
  },
}
</script>
<style lang="scss" scoped>
.login {
  &__container {
    width: 400px;
    margin: 100px auto;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 45px;
      &__icon {
        &--logo {
          width: 31.6px !important;
          height: 24px !important;
          color: var(--bgGreen) !important;
        }
        &--text {
          width: 79.5px !important;
          height: 24px !important;
          margin-left: 5px;
          color: var(--logoColor) !important;
        }
      }
      &__text {
        font-size: 20px;
        font-weight: 600;
        color: var(--textBlack);
      }
    }
    &__form {
      &__action {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
      }
      &__wx {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--loginWxBg);
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 16px 20px;
        color: #07c160;
        cursor: pointer;
        span {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.login {
  &__container {
    &__form {
      .el-input {
        margin-bottom: 15px;
        .el-input__inner {
          height: 56px;
          line-height: 56px;
          border-radius: 6px;
          border: 1px solid rgba(239, 239, 239, 1);
          background: var(--loginInputBg);
          color: var(--memoContentColor);
        }
      }
      .el-button {
        width: 100%;
        background: var(--bgGreen);
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 20px 20px;
        margin-bottom: 30px;
        color: var(--memberPlanColor);
        &:hover {
          background: var(--bgGreen);
          border: 1px solid var(--loginBtnBorder);
        }
      }
      .el-link.el-link--default {
        color: var(--tagColor);
        font-weight: unset;
      }
    }
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 600px) {
  .login {
    &__container {
      width: 350px;
    }
  }
}
</style>
